import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { MicroUiMoleculeModule } from '@micro-ui/molecule';
import { TranslateModule } from '@ngx-translate/core';
import { SharedDesktopModule } from '@brightside-web/shared/desktop';
import { BsChatService } from '@brightside-web/desktop/data-access/core-services';

@Component({
    selector: 'bw-hardship-intro',
    imports: [CommonModule, BrightsideUiModule, MicroUiMoleculeModule, TranslateModule, SharedDesktopModule],
    templateUrl: './hardship-intro.component.html',
    styleUrl: './hardship-intro.component.scss'
})
export class HardshipIntroComponent {

  private _bsChatSvc = inject(BsChatService);

  eligibilityItems = [
    {key: 'HARDSHIP_INTRO_ITEM_1', icon: 'checkmark'},
    {key: 'HARDSHIP_INTRO_ITEM_2', icon: 'checkmark'},
    {key: 'HARDSHIP_INTRO_ITEM_3', icon: 'checkmark'},
    {key: 'HARDSHIP_INTRO_ITEM_4', icon: 'close'},
  ];

  openChat() {
    this._bsChatSvc.showChat();
  }
}
